import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { Modification, ModificationWithRegionsAndTasksDTO } from 'src/services/modification/types';

import ModificationService from '../services/modification/modificationService';

// **** Types **** //

interface ModificationsState {
  modifications: Modification[];
  taskModificationConfigTableData: ModificationWithRegionsAndTasksDTO[];
}

// **** API Calls **** //

export const getModifications = createAsyncThunk('modifications/getModifications', () =>
  ModificationService.getModifications(),
);

export const getTaskModificationConfigTableData = createAsyncThunk(
  'modifications/getTaskModificationConfigTableData',
  () => ModificationService.getModificationWithRegionsAndTasksDTOList(),
);

// **** Setup **** //

const initialState: ModificationsState = {
  modifications: [],
  taskModificationConfigTableData: [],
};

const { reducer } = createSlice({
  name: 'modificationsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getModifications.fulfilled, (state, { payload }) => {
      state.modifications = payload;
    });
    builder.addCase(getTaskModificationConfigTableData.fulfilled, (state, { payload }) => {
      state.taskModificationConfigTableData = payload;
    });
  },
});

// **** Export **** //

export default reducer;
